import { FileUpload } from "@/components/FileUpload";

export function FilesPage() {
	return (
		<div className="max-w-2xl mx-auto space-y-6">
			<h1 className="text-2xl font-bold text-foreground">Files</h1>
			<FileUpload />
		</div>
	);
}
